var GeneralReport = (function () {

  //http://render.openstreetmap.org/cgi-bin/export?bbox=77.72827148437501,50.57626025689928,87.38525390625001,54.50832650029076&scale=1600000&format=svg
  //inkscape map.svg --export-png=map.png --export-dpi=300

  //Leaflet объект карты
  var _map = null;
  var view = {};
  var loadingPlaceholder = '<option disabled selected hidden>Загрузка данных...</option>';
  var option = function (text, value, selected) {
    return '<option value="{0}" {2}>{1}</option>'.format(value, text, selected ? 'selected' : '');
  };
  var _config = {
    zoom: 9,
    center: AppConfig.defaultMapCenter,
    maxBounds: AppConfig.defaultMapBounds,
    //географические границы области
    bounds: [[50.57626025689928, 77.72827148437501], [54.50832650029076, 87.38525390625001]]
  };
  var _image = null;

  //Функция для получения цвета линии для различных типов работ
  var getWorkCategoryColors;


  /**
   * Функция инициализации страницы отчета
   */
  function init(workCategoryColors) {

    var $datetimepickerFrom = $('#From').closest('.date');
    var $datetimepickerTo = $('#To').closest('.date');
    var datetimepickerFrom = $datetimepickerFrom.datetimepicker({
      locale: 'ru',
      format: 'DD-MM-YYYY',
      allowInputToggle: true
    });
    var datetimepickerTo = $datetimepickerTo.datetimepicker({
      locale: 'ru',
      format: 'DD-MM-YYYY',
      allowInputToggle: true,
      useCurrent: false //Important! See issue #1075
    });
    // Если у инпута "С" есть значение, то ограничиваем datetimepicker "По"
    if ($('#From').val()) {
      $datetimepickerTo.data("DateTimePicker").minDate($('#From').val());
    }
    // Если у инпута "По" есть значение, то ограничиваем datetimepicker "С"
    if ($('#To').val()) {
      $datetimepickerFrom.data("DateTimePicker").maxDate($('#To').val());
    }
    // Если произошел ввод значения в datetimepicker "С" есть значение, то ограничиваем datetimepicker "По"
    $datetimepickerFrom.on("dp.change", function (e) {
      $datetimepickerTo.data("DateTimePicker").minDate(e.date);
    });
    // Если произошел ввод значения в datetimepicker "По" есть значение, то ограничиваем datetimepicker "С"
    $datetimepickerTo.on("dp.change", function (e) {
      $datetimepickerFrom.data("DateTimePicker").maxDate(e.date);
    });

    initMap();

    //$cmbRoads
      view.$cmbRoads = $('[name=Roads]');
      view.$cmbRoads.chosen();
      view.$cmbRoads.empty().append(loadingPlaceholder);

    //$cmbWorks
    view.$cmbWorks = $('[name=Works]');
    view.$cmbWorks.chosen();
    view.$cmbWorks.empty().append(loadingPlaceholder);

    //$txtFrom
    view.$txtFrom = $('[name=From]');

    //$txtTo
    view.$txtTo = $('[name=To]');

    //$btnSubmit
    view.$btnSubmit = $('[js=submit]');
    view.$btnSubmit.on('click', submitClicked);

    //$btnGenerate
    view.$btnGenerate = $('[js=generate]');
    view.$btnGenerate.on('click', generateClicked);

    view.busy = function (isBusy) {
      $('#general-report').toggleClass('busy', isBusy);
    };

    getWorkCategoryColors = function(id) {
      return workCategoryColors[id] || '#FFFFCC';
    };

    onInitFinish();
  };

  //Вернет коллекцию ЗО
  function getServiceZones(data) {
    return $.get(Url.api('api/serviceZones/map'), data);
  }

  /**
 * Создаст слой для зон обслуживания
 * @param {ServiceZone} serviceZone Модель зоны обслуживания
 * @returns {Layer}
 */
  function createServiceZoneLayer(serviceZone) {
    if (serviceZone.Coordinates.length <= 0) return undefined;

    var polygonPoints = MapHelper.convertToLatLng(serviceZone.Coordinates);

    var polygon = new L.Polygon(polygonPoints, {
      color: '#' + serviceZone.Color.Name,
      weight: 2,
      smoothFactor: 1,
      opacity: .9,
      fillOpacity: .8,
      clickable: false
    });

    return polygon;
  };

  // Обновит легенду ЗО
  function serviceZoneLegendUpdate(serviceZone, $g, pointRect, pointSpan) {
    var serviceZoneColor = serviceZone.Color ? serviceZone.Color.Name : 'ffffff';
    var serviceZoneContractor =serviceZone.Contractor ? serviceZone.Contractor.Name : '';
    var legendItemRect = '<rect style="fill:#' + serviceZoneColor + ';fill-opacity:0.8;stroke:#000000;stroke-width:1;" width="60" height="30" x="' + pointRect.x + '" y="' + pointRect.y + '" />';
    var legendItemText = '<text style="font-size:18pt;line-height:125%;font-family:sans-serif;"> <tspan  x="' + pointSpan.x + '" y="' + pointSpan.y + '">- ' + serviceZoneContractor + '</tspan> </text>';

    // Изменение позиции для следующего эл-та в легенде
    pointRect.y += 40;
    pointSpan.y += 40;

    $g.append(legendItemRect).append(legendItemText);

    return { g: $g, pointRect: pointRect, pointSpan: pointSpan }
  }

  // Добавит Зоны Обслуживания на карту
  function drawServiceZone(legend) {
    var getData = function (page, count) {
      return getServiceZones({ page: page, count: count });
    };

    var pointRect = { x: 30, y: 80 };
    var pointSpan = { x: 110, y: 100 };

    var $g = $(legend);

    var newLegendAsync = getData(0, 100).then(function (response) {
      response.Data.forEach(function (serviceZone) {
        var layer = createServiceZoneLayer(serviceZone);
        if (layer) _map.addLayer(layer);
        layer.bringToBack(); // Всегда в самом низу

        var newLegendData = serviceZoneLegendUpdate(serviceZone, $g, pointRect, pointSpan);
        $g = newLegendData.g;
        pointRect = newLegendData.pointRect;
        pointSpan = newLegendData.pointSpan;
      });
      for (var i = 1; i < response.PageCount; i++) {
        getData(i, 100).then(function (response2) {
          response2.Data.forEach(function (serviceZone) {
            var layer = createServiceZoneLayer(serviceZone);
            if (layer) _map.addLayer(layer);
            layer.bringToBack(); // Всегда в самом низу

            var newLegendData = serviceZoneLegendUpdate(serviceZone, $g, pointRect, pointSpan);
            $g = newLegendData.g;
            pointRect = newLegendData.pointRect;
            pointSpan = newLegendData.pointSpan;
          });
        });
      }

      // Изменение размера легенды
      var g = $g.children().first();
      var lgPosition = response.PageCount * response.Data.length * 50;
      $(g).attr('height', Number($(g).attr('height')) + lgPosition);

      legend = $g[0].outerHTML;

      return [legend, lgPosition];
   });

   return newLegendAsync;
  }

  function initLegendsPosition(_map, legend, plPoint, legendZone, plzPoint) {
    var pl = _map.latLngToLayerPoint([50.57626025689928, 87.38525390625001]);
    // Сдвиг легенды условных обозначений вверх
    pl.x -= plPoint.x;
    pl.y -= plPoint.y;

    L.DomUtil.setPosition(legend, pl);

    var plz = _map.latLngToLayerPoint([50.57626025689928, 87.38525390625001]);
    // Сдвиг легенды Зон Обслуживания вверх
    plz.x -= plzPoint.x;
    plz.y -= plzPoint.y;

    L.DomUtil.setPosition(legendZone, plz);
  }

  /**
   * Инициализирует карту Leaflet
   */
  function initMap() {

    //var grayscale = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
    //  attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    //  noWrap: true
    //});
    //var streets = L.tileLayer('http://{s}.tile.thunderforest.com/transport/{z}/{x}/{y}.png', {
    //  attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    //  noWrap: true
    //});
    //var grayscale2 = L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', {
    //  attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    //  noWrap: true
    //});

    if (_map) {
      _map.remove();
    }

    _map = L.map('map', {
      zoom: _config.zoom,
      minZoom: _config.zoom - 2,
      maxZoom: _config.zoom + 1,
      //layers: [grayscale],
      maxBounds: L.latLngBounds(_config.maxBounds[0], _config.maxBounds[1]),
      zoomReverse: true,
      center: _config.center,
      renderer: L.svg({ padding: 2 })
    });

    //создаем два масштабиремых SVG слоя для отображения изображения карты ...
    _map.addLayer(L.SvgScaleOverlay({ pane: 'tilePane' }));
    //... и для отображения попапов
    _map.addLayer(L.SvgScaleOverlay({ pane: 'popupPane' }));

    //вычисляем геометрические границы и размеры карты
    var points = _config.bounds.map(function (x) { return _map.latLngToLayerPoint(x); });
    var bounds = L.bounds(points);
    var size = bounds.getSize();


    var imgUrl = Url.content('Content/img/general-report-map.png');

    if (!_image) {
      _image = new Image();
      _image.src = imgUrl;
    }

    var svg = $(_map.getPane('tilePane')).find('svg > g');
    svg.append(SvgHelper.create('image', {
      'xlink:href': imgUrl,
      x: bounds.min.x,
      y: bounds.min.y,
      height: size.y,
      width: size.x
    }));


    svg = $(_map.getPane('popupPane')).find('svg > g');

    var legend = SvgHelper.create('g', {});
    legend.innerHTML = $('#legend-tmpl').html();
    svg.append(legend);

    var legendZone = SvgHelper.create('g', {});
    legendZone.innerHTML = $('#legend-zone-tmpl').html();
    svg.append(legendZone);

    // Сдвиг легенд
    initLegendsPosition(_map, legend, { x: 620, y: 620 }, legendZone, { x: 820, y: 100 });

    drawServiceZone(legendZone.innerHTML)
      .done(function (response) {
        legendZone.innerHTML = response[0];
        svg.append(legendZone);

        // Сдвиг легенд
        initLegendsPosition(_map, legend, { x: 620, y: (620 + response[1]) }, legendZone, { x: 820, y: (100 + response[1]) });
      });
  };


  /**
   * Выполнится когда закончится инициализация представления страницы
   */
  function onInitFinish() {
    //загружаем справочник дорог
      getRoads()
          .done(function (roads) {
              var options = roads.map(function (x) { return option(x.Name, x.Id); });
              view.$cmbRoads.empty().append(options).trigger("chosen:updated");
          });
      //загружаем справочник работ
      getWorks(view.$cmbRoads.val())
      .done(function (works) {
        var options = works.map(function (x) { return option(x.Name, x.Id); });
        view.$cmbWorks.empty().append(options).trigger("chosen:updated");
      });
  };


  /**
   * Обработает событие нажатия кнопки "Применить"
   */
  function submitClicked() {
    var roadIds = view.$cmbRoads.val();
    var workIds = view.$cmbWorks.val();
    var from = view.$txtFrom.val();
    var to = view.$txtTo.val();

    view.busy(true);

      getReport(roadIds, workIds, from, to).done(function (reportData) {
          drawReport(reportData);
          view.busy(false);
      });
  };

  /**
   * Обработает событие нажатия кнопки "Сгенерировать"
   * @returns {} 
   */
  function generateClicked() {

    //_map.on('zoomend', function () {
    //  _map.off('zoomend');
    //});

    view.busy(true);

    _map.setZoom(_config.zoom);
    _map.panTo(_config.center);

    //Установил здесь timeout для того, чтобы успели обновиться слои L.SvgScaleOverlay.
    //Если неоходимо убрать timeout, то нужно учитывать что слои L.SvgScaleOverlay сами подписываются на события 'moveend'
    //и не уведомляют, когда заканчивают свою отрисовку
    setTimeout(function () {

      exportToBase64()
        .then(function(base64Image) {
          var docDefinition = {
            pageSize: 'A3',
            pageOrientation: 'landscape',
            pageMargins: [15, 15, 15, 15],
            content: [
              {
                image: base64Image,
                width: 1160,
                height: 777
              }
            ]
          };
          pdfMake.createPdf(docDefinition).download('Общий отчет.pdf');
          view.busy(false);
        })
        .catch(function(ex) {
          console.log(ex);
          alert('Отчет не построен');
          view.busy(false);
        });

    }, 2000); //2 секунды ждем отрисовку карты
  };

  /**
   * Отрисует отчет на карте
   * @param {} report Модель отчета
   */
  function drawReport(report) {

    initMap();

      report.roads.forEach(function (road) {
          drawRoad(road);
      });
      report.works.forEach(function (work) {
          var road = report.roads.filter(function (x) { return x.Id === work.RoadId; })[0];
          drawWork(work, road);
      });
  };

  /**
   * Нарисует дорогу на карте
   * @param {WorkGeneralReportViewModel} work Модель дороги
   */
    function drawRoad(road) {
        var coordinates = MapHelper.convertToLatLng(road.Coordinates);
        L.polyline(coordinates, {
            color: road.Type.Id === 1 ? "#A52A2A" : road.Type.Id === 2 ? "#393939" : "#808080",
      weight: 2,
      smoothFactor: 1,
      opacity: .8
    }).addTo(_map);
  };

    /**
    * Нарисует дорогу на карте
    * @param {WorkGeneralReportViewModel} work Модель работы
    * @param {} road Модель дороги
    */
    function drawWork(work, road) {

        if (!road) {
            console.error('Road {RoadId} not found'.format(work));
            return;
        }

        //конвертируем наши координаты в координаты Leaflet
        var roadCoordinates = MapHelper.convertToLatLng(road.Coordinates);

        //получаем координаты участка работы
        var coordinates = MapHelper.getCoordinatesByStartEnd(roadCoordinates, (work.StartKm - road.StartKm)* 1e3, (work.StopKm - road.StartKm) * 1e3);

        if (coordinates.length === 0) {
            console.error('Work {RoadId} has no coordinates'.format(work));
            return;
        }

    //рисуем участок работы
    L.polyline(coordinates, {
      color: getWorkCategoryColors(work.WorkCategoryId),
      weight: 8,
      smoothFactor: 0,
      opacity: 1,
      lineCap: 'butt'
    }).addTo(_map);

        //географическая точка на участке дороги, на которую указывает popup
        var location = {};
        if (Array.isArray(coordinates[0])) {
            location = coordinates[0][0];
        } else {
            location = coordinates[0];
        }

        var position = _map.latLngToLayerPoint(location);

        var text = work.Name + '\r\n' + road.Name + '\r\n'
      + 'км ' + work.StartKm.toFixed(3).replace('.', '+')
      + ' - ' + work.StopKm.toFixed(3).replace('.', '+');

    $.each(work.LongObjects, function (longObject) {
      if (longObject.Name) {
        text += '\r\n' + longObject.Name;
      }
    });

    //добавляем balloon для работы
    addBalloon(location, position, text, {
      background: work.IsContinued ? '#C5D373' : '#F6AD71'
    });
  };


  /**
   * Загрузит с сервера модели дорог
   * @returns {Object} Объект promise
   */
    function getRoads() {
        return $.getJSON(Url.api('roads/min'));
    };

    /**
   * Загрузит с сервера модели работ по идентификатору дороги
   * @param {number[]} roadIds Идентификаторы дорог
   * @returns {Object} Объект promise
   */
    function getWorks(roadIds) {
        return $.getJSON(Url.api('works/min'), { roadIds: roadIds });
    };

  /**
   * Загрузит с сервера данные для формирования общего отчета
   * @param {number[]} roadIds Идентификаторы дорог
   * @param {number[]} workIds Идентификаторы работ
   * @param {Date} from Начальная дата отчета
   * @param {Date} to Конечная дата отчета
   * @returns {Object} Объект promise
   */
  function getReport(roadIds, workIds, from, to) {
    return $.post(Url.api('report/getGeneralReport'), {
      roadIds: roadIds || [],
      workIds: workIds || [],
      from: from,
      to: to
    });
  };


  /**
   * Нарисует на карте balloon
   * 
   * @public
   * @param {LatLng} location Точка на карте, на которую указывает balloon
   * @param {LatLng} position Точка на карте, от которой начнется отрисовка balloon
   * @param {string} content Содержимое balloon в виде HTML
   * @param {Object} params Дополнительные параметры для отрисовки balloon: цвет, шрифт и т.д. (пока неспецифицирован)
   */
  function addBalloon(location, position, content, params) {

    var svg = $(_map.getPane('popupPane')).find('svg > g');
    var text = SvgHelper.create('text', { y: 5, 'font-size': 16 });

    content.split('\r\n').forEach(function (line) {
      text.appendChild(SvgHelper.create('tspan', { x: 10, dy: '1.25em' }, line));
    });

    //преобразуем географические координаты, в координаты слоя
    var loc = _map.latLngToLayerPoint(location);

    var path = SvgHelper.create('path', { 'fill': params.background, 'stroke': '#333333', 'stroke-width': 1 });
    svg.append(path);

    var popup = SvgHelper.create('g', { 'class': 'leaflet-balloon' });
    popup.appendChild(text);
    svg.append(popup);
    popup.prepend(SvgHelper.create('rect', {
      'x': 0, 'y': 0,
      'width': popup.getBBox().width + 20,
      'height': popup.getBBox().height + 20,
      'fill': params.background
    }));


    L.DomUtil.setPosition(popup, position);
    L.DomEvent.disableClickPropagation(popup);

    var draggable = new L.Draggable(popup);
    draggable.enable();
    draggable.on('drag', function (e) {

      var w = popup.getBBox().width;
      var h = popup.getBBox().height;

      var t = L.DomUtil.getPosition(popup).y;
      var l = L.DomUtil.getPosition(popup).x;

      var a = t + h / 2;
      var b = l + w / 2;

      $(path).attr('d', ['M', l, a, 'Q', b, a, loc.x, loc.y, 'Q', b, a, l + w, a].join(' '));
    });
  };


  /**
   * Генерирует изображение из карты
   */
  function exportToBase64() {

    var points = _config.bounds.map(function (x) { return _map.latLngToLayerPoint(x); });
    var bounds = L.bounds(points);
    var size = bounds.getSize();

    return new Promise(function (resolve, reject) {

      var scale = 1.5;
      var canvas = document.createElement('canvas');
      canvas.width = size.x * scale;
      canvas.height = size.y * scale;

      var ctx = canvas.getContext('2d');

      ctx.drawImage(_image, 0, 0, canvas.width, canvas.height);
      ctx.scale(scale, scale);
      ctx.translate(-bounds.min.x, -bounds.min.y);

      var svgLayers = [
        $(_map.getPane('tilePane')).find('svg')[0],
        $(_map.getPane('overlayPane')).find('svg')[0],
        $(_map.getPane('popupPane')).find('svg')[0]
      ];


      svgLayers.forEach(function (svg) {
        var svgText = new XMLSerializer().serializeToString(svg);
        ctx.drawSvg(svgText, 0, 0, svg.width.baseVal.value, svg.height.baseVal.value);
      });

      resolve(canvas.toDataURL());
    });
  };











  return {
    init: init
  };

}());
